import React from 'react'
import { Page, Document, PDFViewer, PDFDownloadLink} from '@react-pdf/renderer';

import PVContent from './PVContent';
import styles from './styles';
import PdfHeader from '../PdfHeader';
import PdfFooter from '../PdfFooter';

// Create styles
/*const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      backgroundColor: '#E4E4E4'
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1
    }
  });
*/
  export const PVPdfTemplate = ({voucher}) => (
      
    <Document>
        <Page size="A5" 
            orientation='landscape'
            style={styles.page}>
            <PdfHeader />
            <PVContent voucher={voucher}></PVContent>
            <PdfFooter />
        </Page>
    </Document>
);

const PaymentVoucherPdf = ({voucher}) => {

    /*return ReactPDF.render(<PVPdfTemplate />, `${__dirname}/MegaPaymentVoucher.pdf`);
*/
    
    return (
        <div style={{ flexGrow: 1, minHeight: '95vh' }}>
        <PDFViewer
            showToolbar={true}
            style={{width: '100%',
                    height: '90vh',
                }}>
            <PVPdfTemplate voucher={voucher}/>
        </PDFViewer>
        <PDFDownloadLink
            document={<PVPdfTemplate voucher={voucher}/>}
            fileName='MegaPV26012022.pdf'>
            {({blob, url, loading, error}) => (loading ? 'Loading document...' : 'Download PV')}
        </PDFDownloadLink>
        </div>
    );
  
};

export default PaymentVoucherPdf

